import Vue from "vue";
import Router from "vue-router";
// import Index from "./views/Index.vue";
// import Landing from "./views/Landing.vue";
// import Login from "./views/Login.vue";
// import Profile from "./views/Profile.vue";
import Mobile from "./views/mobile.vue";
import Privacy from "./views/privacy.vue";
import Download from "./views/download.vue";
import SetPassword from "./views/SetPassword.vue";
import SetPasswordFinish from "./views/SetPassword_finish.vue";


import RegisterFinish from "./views/register_finish.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    { path: '*', component: Mobile },
    {
      path: "/",
      name: "",
      components: { default: Mobile, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path:"/space/*" ,redirect:"/download"
    },
    {
      path:"/facilityitem/*" ,redirect:"/download"
    },   
   
    // {
    //   path: "/login",
    //   name: "login",
    //   components: { default: Login, header: MainNavbar, footer: MainFooter },
    //   props: {
    //     header: { colorOnScroll: 400 }
    //   }
    // },
    // {
    //   path: "/profile",
    //   name: "profile",
    //   components: { default: Profile, header: MainNavbar, footer: MainFooter },
    //   props: {
    //     header: { colorOnScroll: 400 },
    //     footer: { backgroundColor: "black" }
    //   }
    // },   
     
    {
      path: "/download",
      name: "download",
      components: { default: Download, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/privacy",
      name: "privacy",
      components: { default: Privacy, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/mobile",
      name: "mobile",
      components: { default: Mobile, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/SetPassword",
      name: "Set Password",
      components: { default: SetPassword, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/register_finish",
      name: "register_finish",
      components: { default: RegisterFinish, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/SetPassword_finish",
      name: "SetPassword_finish",
      components: { default: SetPasswordFinish, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/SetPassword/SetPassword_finish",
      name: "SetPassword_finish",
      components: { default: SetPasswordFinish, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    }
    //SetPassword_finish
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});